import React from "react";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import Search from "@radarly/components/navigation/switcher/search";

type Tab = "workspaces" | "queries";

interface NavigationSwitcherSearchPanelProps {
  height: number;
  children: (tab: Tab) => React.ReactNode;
}

export function NavigationSwitcherSearchPanel({
  height,
  children,
}: NavigationSwitcherSearchPanelProps) {
  const locale = useCurrentUserLocale();
  const [tab, setTab] = React.useState<Tab>("workspaces");
  return (
    <Search tab={tab} onChange={setTab} height={height} locale={locale}>
      {children(tab)}
    </Search>
  );
}
